import * as FormTypes from "./FormTypes";

export enum TRAINER {
  "SELF",
  "MANAGER",
}

export default FormTypes;
